import { convertTo62, isUUID } from 'uuid-encoding';

export const convertUUIDTo62OrUndefined = (uuid: string): string | undefined =>
  isUUID(uuid) ? convertTo62(uuid) : undefined;
